/* Option C v10 — Scott round-8:
   • HOMEPAGE-ONLY: the whole layer gates on data-template=index (the steam on
     the product page was this script decorating every template's first section).
   • Marquee → clay.
   • Stats: ONE trigger — when the first number's moment arrives the whole
     sequence chains through automatically; no reset on scroll-up. */
(() => {
  if (!document.documentElement.classList.contains('sm-js')) return;
  const main = document.querySelector('#MainContent');
  if (!main || main.dataset.template !== 'index') return;

  const EASE_MS = 800;
  const countUp = (el, end, suffix, onDone) => {
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / EASE_MS);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else if (onDone) onDone();
    };
    requestAnimationFrame(tick);
  };

  const MARQUEE_TEXT = 'SALT FOR THE SAUNA · 1,000 MG SODIUM · 200 MG POTASSIUM · 60 MG MAGNESIUM · ZERO SUGAR · ';
  const MARQUEE_SPEED = 35;
  const mkMarquee = () => {
    const bar = document.createElement('div');
    bar.className = 'sm-marquee';
    bar.setAttribute('aria-hidden', 'true');
    const track = document.createElement('div');
    track.className = 'sm-marquee__track';
    for (let i = 0; i < 2; i++) {
      const seq = document.createElement('span');
      seq.className = 'sm-marquee__seq';
      seq.textContent = MARQUEE_TEXT.repeat(5);
      track.appendChild(seq);
    }
    bar.appendChild(track);
    requestAnimationFrame(() => {
      const seqW = track.scrollWidth / 2;
      track.style.setProperty('--sm-marquee-dur', `${Math.round(seqW / MARQUEE_SPEED)}s`);
    });
    return bar;
  };

  const setup = () => {
    const secs = [...document.querySelectorAll('#MainContent .shopify-section')];
    if (secs.length < 2) return;

    secs[0].after(mkMarquee());

    const hero = secs[0];
    const heroImg = hero.querySelector('img, video');
    if (heroImg) { heroImg.classList.remove('sm-hero-media'); heroImg.classList.add('sm-hdrift'); }
    const heroContent = hero.querySelector(':scope .section') || null;

    const box = hero.querySelector('[class*="media"]') || hero;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    const glow = document.createElement('div');
    glow.className = 'sm-glow';
    glow.setAttribute('aria-hidden', 'true');
    box.appendChild(glow);
    const c = document.createElement('canvas');
    c.className = 'sm-steam';
    c.setAttribute('aria-hidden', 'true');
    box.appendChild(c);
    const ctx = c.getContext('2d');
    let cw = 0, ch = 0;
    const csize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      cw = c.clientWidth; ch = c.clientHeight;
      c.width = cw * dpr; c.height = ch * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    csize();
    addEventListener('resize', csize, { passive: true });
    const spawnP = (anywhere) => ({ x: 0.1 + Math.random() * 0.8, y: anywhere ? Math.random() * 1.2 : 1.1 + Math.random() * 0.15, r: 60 + Math.random() * 90, s: 0.05 + Math.random() * 0.05, phase: Math.random() * Math.PI * 2, a: 0.08 + Math.random() * 0.07 });
    const PS = Array.from({ length: 14 }, () => spawnP(true));
    let heroVis = true;
    new IntersectionObserver((es) => { heroVis = es[0].isIntersecting; }).observe(hero);
    let pt = 0;
    const steamLoop = (t) => {
      requestAnimationFrame(steamLoop);
      if (!heroVis) { pt = t; return; }
      const dt = Math.min(50, t - pt);
      if (dt < 30) return;
      pt = t;
      ctx.clearRect(0, 0, cw, ch);
      ctx.globalCompositeOperation = 'lighter';
      PS.forEach((p) => {
        p.y -= p.s * (dt / 1000);
        p.x += Math.sin(t / 2600 + p.phase) * 0.0009;
        if (p.y < -0.25) Object.assign(p, spawnP(false));
        const fade = Math.max(0, Math.min(1, (1.08 - p.y) * (p.y + 0.3) * 2.2));
        const g = ctx.createRadialGradient(p.x * cw, p.y * ch, 0, p.x * cw, p.y * ch, p.r);
        g.addColorStop(0, `rgba(245,239,227,${(p.a * fade).toFixed(3)})`);
        g.addColorStop(1, 'rgba(245,239,227,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(p.x * cw, p.y * ch, p.r, 0, 7);
        ctx.fill();
      });
    };
    requestAnimationFrame(steamLoop);

    if (heroContent) {
      const els = [...heroContent.querySelectorAll('h1, h2, p, a, button')].slice(0, 6);
      els.forEach((el, i) => {
        el.classList.add('sm-rise');
        el.style.setProperty('--sm-delay', `${180 + i * 130}ms`);
      });
      requestAnimationFrame(() => requestAnimationFrame(() => els.forEach((el) => el.classList.add('sm-rise--in'))));
      setTimeout(() => els.forEach((el) => {
        el.classList.remove('sm-rise', 'sm-rise--in');
        el.style.removeProperty('--sm-delay');
      }), 2400);
    }

    const lastSec = secs[secs.length - 1];
    const heroBtn = hero.querySelector('a.button, .button');
    if (heroBtn && lastSec) {
      heroBtn.addEventListener('click', (e) => {
        e.preventDefault();
        lastSec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    const rsec = secs.find((s) => /Tear\. Pour\. Stir\. Drink\./.test(s.textContent));
    if (rsec) {
      const p = [...rsec.querySelectorAll('p')].find((el) => /Tear\. Pour\. Stir\. Drink\./.test(el.textContent));
      if (p) {
        p.innerHTML = p.innerHTML.replace(
          'Tear. Pour. Stir. Drink.',
          '<br><span class="sm-step">Tear.</span> <span class="sm-step">Pour.</span> <span class="sm-step">Stir.</span> <span class="sm-step">Drink.</span>'
        );
      }
    }

    const scenes = secs.slice(1).map((sec) => {
      const isLast = sec === lastSec;
      const isRitual = sec === rsec;
      const inner = sec.querySelector(':scope .section') || null;
      if (inner && !isLast) inner.classList.add('sm-scene');
      const imgs = [...sec.querySelectorAll('img')].filter((i) => i.offsetHeight > 200 && i.offsetWidth > 200);
      imgs.forEach((i) => {
        i.classList.remove('sm-parallax');
        i.classList.add('sm-scene-img');
        if (isRitual) i.classList.add('sm-develop');
        if (i.parentElement) i.parentElement.classList.add('sm-par-clip');
      });
      const numGroups = [];
      const h3s = [...sec.querySelectorAll('h3')].filter((h) => /^\d/.test(h.textContent.trim()));
      if (h3s.length >= 3) {
        delete sec.dataset.smStats;
        [...sec.querySelectorAll('.sm-reveal')].forEach((el) => {
          el.classList.remove('sm-reveal', 'sm-in');
          el.style.removeProperty('--sm-delay');
        });
        h3s.forEach((h3, gi) => {
          const m = h3.textContent.trim().match(/^(\d+)(.*)$/);
          if (!m) return;
          h3.classList.add('sm-num');
          h3.textContent = '0' + (m[2] || '');
          numGroups.push({ h3, gi, end: parseInt(m[1], 10), suffix: m[2] || '' });
        });
      }
      return { sec, isLast, isRitual, inner, imgs, numGroups, chainStarted: false, steps: isRitual ? [...sec.querySelectorAll('.sm-step')] : [] };
    });

    const runChain = (groups, i) => {
      if (i >= groups.length) return;
      const g = groups[i];
      g.h3.classList.add('sm-num--lit');
      countUp(g.h3, g.end, g.suffix, () => runChain(groups, i + 1));
    };

    let raf = null;
    const schedule = () => { if (!raf) raf = requestAnimationFrame(frame); };
    function frame() {
      raf = null;
      const vh = innerHeight;
      const docMax = document.documentElement.scrollHeight - vh;

      if (heroImg) {
        const hp = Math.max(0, Math.min(1, scrollY / (hero.offsetHeight * 0.9 || 1)));
        heroImg.style.setProperty('--sm-hy', `${(hp * 56).toFixed(1)}px`);
        heroImg.style.setProperty('--sm-hzoom', (1 + hp * 0.08).toFixed(3));
        if (heroContent) heroContent.style.transform = `translateY(${(hp * -26).toFixed(1)}px)`;
      }

      scenes.forEach((scene) => {
        const { sec, isLast, isRitual, inner, imgs, numGroups, steps } = scene;
        const r = sec.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const docTop = r.top + scrollY;
        const minTop = Math.max(-r.height, docTop - docMax);
        const span = vh - minTop;
        const p = Math.max(0, Math.min(1, (vh - r.top) / (span || 1)));

        if (inner && !isLast) inner.style.transform = `translateY(${(30 - p * 60).toFixed(1)}px)`;
        imgs.forEach((img) => {
          img.style.transform = isLast
            ? `scale(${(1.04 + p * 0.08).toFixed(3)})`
            : `translateY(${(40 - p * 80).toFixed(1)}px) scale(${(1.12 + p * 0.1).toFixed(3)})`;
        });

        const gateTop = vh * 0.75;
        const ap = Math.max(0, Math.min(1, (gateTop - r.top) / (gateTop - Math.max(minTop, -r.height * 0.6))));

        if (isRitual) imgs.forEach((img) => { img.style.filter = `brightness(${(0.55 + ap * 0.45).toFixed(3)})`; });

        if (numGroups.length && !scene.chainStarted && ap > 0.15) {
          scene.chainStarted = true;
          runChain(numGroups, 0);
        }
        steps.forEach((s, i) => s.classList.toggle('sm-step--lit', ap > 0.15 + i * 0.1));
      });
      document.body.classList.toggle('sm-scrolled', scrollY > 24);
    }
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    frame();
  };

  if (document.readyState === 'complete') setup();
  else addEventListener('load', setup, { once: true });
})();
